import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gl0002',
    ecrans: ['00-2'],
    params: [
        '?ecjcleint',
        '?fewcleint',
        '?fxmcleint'
            ]
});
